// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2lpTL","content":"Consent_content__2LgRs","footer":"Consent_footer__1FUeW"};